import * as React from 'react';

import classNames from 'classnames';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import styles from './add-inbox.module.css';

type Props = {
    name: string;
    userInboxCount: number;
    isActive: boolean;
    avatarUrl: string;
    initials: string;
    isHovered: boolean;
    isEmbedded: boolean;
};

export function ButtonContent(props: Props) {
    const styleName = classNames(styles['add-inbox-line'], {
        [styles['add-inbox-line--active']]: props.isActive,
        [styles['add-inbox-line--hover']]: props.isHovered,
        [styles['add-inbox-line--embedded']]: props.isEmbedded,
    });

    return (
        <>
            <div className={styleName} />
            <div className='flex justify-sb'>
                <StackLegacy isHorizontal={true} spacing={6}>
                    {props.avatarUrl && (
                        <div className='flex align-center justify-center mr-16'>
                            <img
                                src={`${props.avatarUrl}?width=100&height=100`}
                                className={styles['avatar-image']}
                            />
                        </div>
                    )}
                    {props.initials && (
                        <div
                            className={
                                props.isActive ? styles['initials--active'] : styles.initials
                            }
                        >
                            {props.initials}
                        </div>
                    )}
                    <div
                        className={
                            props.isActive ? styles['button-text--active'] : styles['button-text']
                        }
                    >
                        {props.name}
                    </div>
                </StackLegacy>
                <Body size='small' color={props.isActive ? 'navy-dk' : 'white'}>
                    {props.userInboxCount}
                </Body>
            </div>
        </>
    );
}
